var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"filters":_vm.filters,"hasMore":_vm.hasMore,"isLoading":_vm.isLoading,"results":_vm.results})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }